export default {"src":"/_next/static/media/gezondheidscheck.aad6cf59.svg","height":68,"width":52,"blurWidth":0,"blurHeight":0};